const customers_prepaid = new Map<string, boolean>([
    ['amount', true]
]);

export const filtersMenuDisabled = {
    customers_prepaid
};
